import { FormlyFieldConfig } from '@ngx-formly/core';
import { AutoCompleteSearchType } from 'src/app/common/model/util.model';
export const CreateContactFormlyFields: FormlyFieldConfig[] = [
  {
    key: 'name',
    type: 'input',
    props: {
      label: 'Name',
      placeholder: 'Enter Name',
      required: true
    }
  },

  {
    fieldGroupClassName: 'grid',
    fieldGroup: [
      {
        className: 'sm:col-6 col-12',
        key: 'phoneNumber',
        type: 'input',
        props: {
          type: 'text',
          label: 'Phone Number',
          placeholder: 'Enter Phone Number'
        }
        // validators: {
        // validation: ['phone'],
        // },
        // expressionProperties: {
        //     'props.required': '!model.email'
        // }
      },

      {
        className: 'sm:col-6 col-12',
        key: 'email',
        type: 'input',
        props: {
          label: 'Email Address',
          placeholder: 'Enter Email Address',
          type: 'email'
        }
        // validators: {
        // validation: ['email'],
        // },
        // expressionProperties: {
        //     'props.required': '!model.phoneNumber'
        // }
      }
    ]
  },
  {
    fieldGroupClassName: 'grid',
    fieldGroup: [
      {
        className: 'sm:col-4 col-12',
        key: 'city',
        type: 'input',
        props: {
          label: 'Location',
          placeholder: 'Enter Location'
        }
      },
      {
        className: 'sm:col-4 col-12',
        key: 'address',
        type: 'input',
        props: {
          label: 'Address',
          placeholder: 'Enter Address'
        }
      },
      {
        className: 'sm:col-4 col-12',
        key: 'postalCode',
        type: 'input',
        props: {
          type: 'number',
          label: 'Postal Code',
          placeholder: 'Enter Postal Code'
        }
      }
    ]
  },
  {
    fieldGroupClassName: 'grid',
    fieldGroup: [
      {
        className: 'sm:col-6 col-12',
        key: 'twitter',
        type: 'input',
        props: {
          label: 'Twitter username',
          placeholder:
            'Enter your twitter username without the @ i.e. if your username is @johnDoe just enter johnDoe'
        }
      },
      {
        className: 'sm:col-6 col-12',
        key: 'messenger',
        type: 'input',
        props: {
          label: 'Facebook Username',
          placeholder:
            'Enter your facebook username found in your profile page url i.e. https://www.facebook.com/john.doe. Just enter john.doe'
        }
      }
    ]
  },
  {
    className: 'col-12 sm:col-4',
    key: 'assignedTo',
    type: 'autoComplete',
    props: {
      label: 'Point of contact',
      placeholder: 'Type to Search for a member...',
      searchConfig: {
        searchType: AutoCompleteSearchType.MEMBER,
        fieldName: 'user.fullname',
        fieldValue: '_id',
        selectionLimit: 1,
        multiple: true
      }
    }
  }
  // {
  //     key: 'isSubCustomerCheck',
  //     type: 'checkbox',
  //     hideExpression: 'model.contactType != "INDIVIDUAL"',
  //     props: { label: 'Is sub customer?' },
  //   },
  //   {
  //     key: 'organizationToAddCustomer',
  //     type: 'select',
  //     expressionProperties: {
  //       'props.disabled': '!formState.isSubCustomer',
  //     },
  //     hideExpression: '!model.isSubCustomerCheck',
  //     props: {
  //       placeholder: 'Select Parent Customer',
  //       options: [],
  //     },
  //   },
];
